
import Vue from 'vue';
import _ from 'lodash'; 
export default class lenguajeHelper {
    constructor(Vue) {
        if (Vue) {
            this.vue = Vue;
        
        }
    }
  texts = {
      "es" : {
          "Select the players"          :"Seleccione los jugadores",
          "Select Date"                 :"Seleccione una fecha",
          "Reservation includes"        :"Incluido en la reserva",
          "Balls and Golf Clubs"        :"Pelotas y Bastones",
          "Availability"                :"Disponibilidad",
          "Select Time"                 :"Seleccione Hora",
          "Hours of play"               :"Horas de juego",
          "Minutes"                     :"Minutos",
          "Player Type"                 :"Tipo Jugador",
          "Check Availability"          :"Consultar Disponibilidad",
          "Top Tracer Availability"     :"Disponibilidad de Top Tracer",
          "From"                        :"De",
          "To"                          :"a",
          "Players"                     :"Jugadores",
          "Play Time"                   :"Tiempo de juego",
          "Add to Reservation"          :"Seleccionar Horario",
          "Back"                        :"Regresar",
          "Players information"         :"Información de los jugadores",
          "Player"                      :"Jugador",
          "Email required"              :"Información del correo requerida",
          "Phone Number"                :"Numero Telefonico (opcional)",
          "Name"                        :"Nombre",
          "Email"                       :"Email",
          "Phone Number (Optional)"     :"Numero Telefonico (Opcional)",
          "Book Now"                    :"Reservar Ahora",
          "Date"                        :"Fecha",
          "Loading Availability"        :"Cargando Disponibilidad",
          "Booking"                     :"Reservando",
          "Suggested times"             :"Horarios Sugeridos",
          "Book now?"                   :"¿Deseas generar esta reserva?",
          "Book now"                    :"Reservar Ahora",
          "Reserved"                    :"Reservado",
          "Transportation number"       :"Numero de transportación",
          "Error saving reservation"    :"Error guardando la reserva",
          "Range of times is unavailable. We suggest the follow options":"No se encontro disponibilidad. Te sugerimos los siguientes horarios",
          "Se requiere presentar INE o IFE vigente":"Se requiere presentar INE o IFE vigente",
          "You will not be able to modify your reservation later":"Los datos de la reserva no podran ser modificados posteriormente",
          "Your reservation is done, we send an email with reservation info. Reservation No.":"Tu reservación se guardo correctamente, te enviamos un email con la información de la reserva. Reservación No."
      }
  }
  t(text){
    var idioma = navigator.language || navigator.userLanguage;
    let lenguaje = ""
    
    if(idioma == "es-ES" || idioma == "es-MX"	|| idioma == "es-AR" || idioma == "es-CO"){
        lenguaje = "es";
    }
   
    if(lenguaje != ''){
        let lhelper = new lenguajeHelper();
        
        if(lhelper.texts[lenguaje][text]){
            return lhelper.texts[lenguaje][text];
        }else{
            return text;
        }

    }else{
        return text;
    }
    
    
    
  }


}